import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  id: "bookingOverview",
  class: "skeleton"
}
const _hoisted_2 = {
  key: 3,
  class: "search-app"
}
const _hoisted_3 = { class: "hotel center-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingOverviewActive = _resolveComponent("BookingOverviewActive")!
  const _component_BookingOverviewNoQuery = _resolveComponent("BookingOverviewNoQuery")!
  const _component_DotSpinner = _resolveComponent("DotSpinner")!
  const _component_SearchComponentHotel = _resolveComponent("SearchComponentHotel")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_EasyAlert = _resolveComponent("EasyAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasBookingOverview && _ctx.bookingOverview?.bookingSelection)
      ? (_openBlock(), _createBlock(_component_BookingOverviewActive, {
          key: 0,
          "booking-overview": _ctx.bookingOverview,
          searchRequest: _ctx.searchRequest,
          searchQuery: _ctx.searchQuery,
          pageUrls: _ctx.pageUrls,
          selectedRooms: _ctx.selectedRooms,
          pageTexts: _ctx.pageTexts,
          localeStrings: _ctx.localeStrings
        }, null, 8, ["booking-overview", "searchRequest", "searchQuery", "pageUrls", "selectedRooms", "pageTexts", "localeStrings"]))
      : (_ctx.hasBookingOverview)
        ? (_openBlock(), _createBlock(_component_BookingOverviewNoQuery, {
            key: 1,
            pageUrls: _ctx.pageUrls,
            pageTexts: _ctx.pageTexts
          }, null, 8, ["pageUrls", "pageTexts"]))
        : (_openBlock(), _createElementBlock("aside", _hoisted_1, [
            _createVNode(_component_DotSpinner)
          ])),
    (_ctx.showSearchComponent)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(_component_SearchComponentHotel),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-primary search-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickDatePicker && _ctx.clickDatePicker(...args)))
            }, _toDisplayString(_ctx.pageTexts['searchbarDateLabelChooseDate']), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      bookingOverview: _ctx.bookingOverview,
      selectedRooms: _ctx.selectedRooms,
      searchQuery: _ctx.searchQuery,
      pageTexts: _ctx.pageTexts,
      localeStrings: _ctx.localeStrings
    }, null, 8, ["bookingOverview", "selectedRooms", "searchQuery", "pageTexts", "localeStrings"]),
    _createVNode(_component_EasyAlert, {
      alertHeader: _ctx.pageTexts['hotelPageGeneralErrorHeadline'],
      alertText: _ctx.alertMessage,
      closeBtnText: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
      isShowAlert: _ctx.isShowAlert,
      onCloseAlert: _ctx.closeAlert
    }, null, 8, ["alertHeader", "alertText", "closeBtnText", "isShowAlert", "onCloseAlert"])
  ], 64))
}